import React from 'react';

import { getChainPrivateApi } from 'api/apiCoreSdk';
import DownloadCsvButton from 'components/wallet/DownloadCsvButton';

export default function DownloadBalanceHistoryCSV({
  disabled,
}: {
  disabled: boolean;
}) {
  return (
    <DownloadCsvButton
      getDownloadUrl={walletAddress =>
        getChainPrivateApi().getInternalBalanceHistoryCsvLink({
          wallet: walletAddress,
        })
      }
      title="Balance History"
      disabled={disabled}
    />
  );
}
